import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./ErrorAlert.module.css";

export default class ErrorAlert extends Component {
  render() {
    const { title, children } = this.props;

    return (
      <div className={styles.container}>
        <h1>{title}</h1>
        {children}
      </div>
    );
  }
}

ErrorAlert.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};
